import { permissionService } from 'shared/services';

import AuditList from '../container/AuditList/AuditList.container';
import AuditDetail from '../container/AuditDetail/AuditDetail.container';

import auditRoute from '.';

const { checkPermission } = permissionService;

const routeAudit = [
  { path: auditRoute.LIST, component: AuditList },
  { path: auditRoute.DETAIL, component: AuditDetail },
];

const AuditNavigation = () =>
  checkPermission('Audit:read', true) ? routeAudit : [];

export default AuditNavigation;
